import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';

import FormSelect from 'retired/FormSelect';
import { selectUser } from 'entities/user/selectors';

import { Privileges } from '../../utils/privileges';

const FormPublishingStatus = ({ user, dispatch, deedApprovalRequired, ...props }) => (
  <>
    <span>{props.label}&nbsp;</span>
    <FormSelect {...props} defaultValue="draft">
      <MenuItem value="draft">Draft</MenuItem>
      <MenuItem value="pending">Pending</MenuItem>
      <MenuItem
        disabled={deedApprovalRequired || !user?.hasPrivilege(Privileges.DEED_PUBLISH_LIVE)}
        value="published"
      >
        Published
      </MenuItem>
    </FormSelect>
  </>
);
FormPublishingStatus.propTypes = {
  label: PropTypes.string,
  user: PropTypes.object,
  dispatch: PropTypes.func,
  deedApprovalRequired: PropTypes.bool,
};
export default connect((state) => ({
  user: selectUser(state),
}))(FormPublishingStatus);
